import { useAuthStore } from '../store/authStore';

// Empty string means same-origin (production behind a single reverse proxy); only undefined falls back to dev default.
const BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:8501';

export async function api<T = any>(
  path: string,
  init: RequestInit = {}
): Promise<T> {
  const { token, logout } = useAuthStore.getState();
  const headers = new Headers(init.headers || {});
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (!headers.has('Content-Type') && init.body && typeof init.body === 'string') {
    headers.set('Content-Type', 'application/json');
  }
  const res = await fetch(`${BASE}${path}`, { ...init, headers });
  if (res.status === 401) {
    logout();
    throw Object.assign(new Error('Unauthorized'), { status: 401 });
  }
  const ct = res.headers.get('content-type') || '';
  const body = ct.includes('application/json') ? await res.json().catch(() => ({})) : await res.text();
  if (!res.ok) {
    const msg = (body && typeof body === 'object' && body.error) || `HTTP ${res.status}`;
    throw Object.assign(new Error(msg), { status: res.status, body });
  }
  return body as T;
}
